import React, { useCallback } from 'react'

import { arrayOf, shape, string, number } from 'prop-types'

import Pagination from 'Pods/Shared/Components/Pagination/Pagination'
import usePagination from 'Pods/Shared/Components/Pagination/usePagination'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import Collection from './Components/Collection'

function CollectionListSection({
  collections = EMPTY_ARRAY,
  pagination: initialPagination = null,
  slotOffset = 0,
  collectionType = 'cg',
}) {
  const collectionsLength = (collections && collections.length) || 0
  const initialTotalCount = (initialPagination && initialPagination.totalCount) || collectionsLength

  const handleFetch = useCallback(() => {
    // TODO: Fetch new data from API when endpoint is ready
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  const {
    currentPage,
    totalPages,
    totalCount,
    perPage,
    handlePageChange,
    handlePerPageChange,
  } = usePagination(
    {
      currentPage: (initialPagination && initialPagination.currentPage) || 1,
      perPage: (initialPagination && initialPagination.perPage) || 5,
      totalPages: (initialPagination && initialPagination.totalPages) || 1,
      totalCount: initialTotalCount,
    },
    handleFetch,
    handleFetch
  )

  if (!collections || !collections.length) {
    return null
  }

  return (
    <section className="collections-list" aria-label="Collections list">
      <div className="collections-list__container">
        {collections.map((collection, index) => (
          <Collection
            key={collection.id}
            collection={collection}
            slot={slotOffset + index + 1}
            collectionType={collectionType}
          />
        ))}
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          perPage={perPage}
          onPageChange={handlePageChange}
          onPerPageChange={handlePerPageChange}
        />
      </div>
    </section>
  )
}

CollectionListSection.propTypes = {
  collections: arrayOf(
    shape({
      id: string.isRequired,
      title: string.isRequired,
      description: string.isRequired,
      href: string.isRequired,
      badge: string,
      previewImages: arrayOf(
        shape({
          id: string.isRequired,
          url: string.isRequired,
          alt: string.isRequired,
        })
      ).isRequired,
    })
  ),
  pagination: shape({
    currentPage: number,
    totalPages: number,
    totalCount: number,
    perPage: number,
  }),
  slotOffset: number,
  collectionType: string,
}

export default CollectionListSection
